import { render, staticRenderFns } from "./photoAlbumItem.vue?vue&type=template&id=4535a158&scoped=true&"
import script from "./photoAlbumItem.vue?vue&type=script&lang=js&"
export * from "./photoAlbumItem.vue?vue&type=script&lang=js&"
import style0 from "./photoAlbumItem.vue?vue&type=style&index=0&id=4535a158&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4535a158",
  null
  
)

export default component.exports